export class DialogStateUtil {
  private static isDialogOpen = false;

  static get isDialogCurrentlyOpen() {
      return this.isDialogOpen;
   }

  static dialogIsClosed() {
      this.isDialogOpen = false;
   }

  static dialogIsOpen() {
      this.isDialogOpen = true;
   }
}
